import styled from 'styled-components';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
export const StyledSnackBar = styled(Snackbar)`
  &.MuiSnackbar-root {
    top: 48px !important;
  }
`;
export const StyledSnackBarContent = styled(SnackbarContent)`
  &.MuiSnackbarContent-root {
    background-color: ${props => props.status === 'success' ? '#4dcb64 !important' : '#e15c5c !important'};
    color: ${props => props.status === 'success' ? '#000000 !important' : '#ffffff !important'};
    border: ${props => props.status === 'success' ? '' : '1px solid #DDA5A5'};
    width: 539px;
    padding: 0px 10px;
    font-size: 13px !important;
    font-family: 'OpenSans-Light';
    display: flex;
    align-content: center;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(199, 199, 199, 0.5);
  }

  .MuiSnackbarContent-message {
    width: 85%;
  }
`;